import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { useCookies } from 'react-cookie'
import { useLocale } from '@merchant-portal/merchant-portal-base'
import { login, loginResetStatus } from '../../store/actions/auth-actions'
import LoginUI from './LoginUI'
import { LoginFormNoCookie, LoginFormWithCookie } from './Form'
import { getText } from '../../internal/TextLabels'
import FlagPicker from '../../components/common/Language/FlagPicker'

const Login = ({ isLoggingIn, ...props }) => {
  const [locale, localeActions] = useLocale()
  const [cookies, , removeCookie] = useCookies(['store', 'country'])
  const getCountryFromCookie = () => cookies.country || { countryCode: null }

  const getStoreFromCookie = () => cookies.store || null

  const [country, setCountry] = useState(getCountryFromCookie())
  const [store, setStore] = useState(getStoreFromCookie())
  useEffect(() => () => props.loginResetStatus(), [])

  const onClearCookie = e => {
    e.preventDefault()
    removeCookie('store')
    setCountry(null)
    setStore(null)
  }

  const onLogin = (e, values) => {
    e.preventDefault()
    let countryVal = values.country || country.countryCode || 'SE'
    localeActions.setCountry(countryVal)

    let storeData = ''
    if (store && store.storeNmbr) {
      storeData = store.storeNmbr
    } else if (values.store !== '') {
      storeData = values.store
    }

    // If resurs user, then remove country (for some reason...?)
    if (values.store === '') {
      countryVal = ''
    }

    props.login({
      country: countryVal,
      password: values.password,
      store: storeData,
      username: values.username,
    })
  }
  const renderLoginForm = language => {
    if (!language) {
      return <FlagPicker onClick={localeActions.setLanguage} />
    }
    if (!country || !store) {
      return (
        <LoginFormNoCookie
          country={getText('login.selectCountry')}
          store={getText('login.storeId')}
          username={getText('login.userNameOrEmail')}
          password={getText('login.password')}
          onLogin={(e, values) => onLogin(e, values)}
          loginText={getText('login.buttonText')}
          isLoggingIn={isLoggingIn}
        />
      )
    }
    return (
      <LoginFormWithCookie
        storeInfo={store}
        usernameLabel={getText('login.userNameOrEmail')}
        passwordLabel={getText('login.password')}
        onLogin={(e, values) => onLogin(e, values)}
        loginText={getText('login.buttonText')}
        isLoggingIn={isLoggingIn}
        onClearCookie={e => onClearCookie(e)}
      />
    )
  }

  return (
    <LoginUI
      title={getText('login.title')}
      noPasswordText={getText('login.passwordForgot')}
      noPasswordLink={getText('login.passwordReset')}
      language={locale.language}
    >
      {renderLoginForm(locale.language)}
    </LoginUI>
  )
}

Login.propTypes = {
  isLoggingIn: PropTypes.bool.isRequired,
  login: PropTypes.func.isRequired,
  loginResetStatus: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
  loginError: state.auth.error,
  isLoggingIn: state.auth.isLoggingIn,
})

const mapDispatchToProps = dispatch => ({
  login: userData => {
    dispatch(login(userData))
  },
  loginResetStatus: () => {
    dispatch(loginResetStatus())
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(Login)
